import React from "react"
import { BiUser } from "react-icons/bi"
import { BsBuilding, BsFiletypeCsv } from "react-icons/bs"
import { HiOutlineClipboardCheck, HiOutlineDocumentText } from "react-icons/hi"
import { MdHistory, MdOutlineAccountBalance, MdOutlinePayments, MdOutlineWarningAmber } from "react-icons/md"
import { RiAdminLine } from "react-icons/ri"

export type MenuSection = {
  title: string
  icon: React.ReactNode
  items: {
    name: string
    path: string
  }[]
  adminOnly?: boolean
}

export const MENU_SECTIONS: MenuSection[] = [
  {
    title: "CS・ユーザー",
    icon: <BiUser />,
    items: [
      { name: "チャット", path: "/admin/chat" },
      { name: "ユーザー一覧", path: "/admin/users" },
      { name: "受電ログ一覧", path: "/admin/incoming-call-logs" },
    ],
  },
  {
    title: "審査関連",
    icon: <HiOutlineClipboardCheck />,
    items: [{ name: "審査一覧", path: "/admin/for-cic" }],
  },
  {
    title: "CIC",
    icon: <BsFiletypeCsv />,
    items: [
      { name: "CIC用CSV（旧ページ）", path: "/admin/fetch-cic-csv" },
      { name: "CFⅡ", path: "/admin/cic-cf2" },
      { name: "CIC登録", path: "/admin/cic-cf2/registration" },
    ],
  },
  {
    title: "クレジット契約関連",
    icon: <HiOutlineDocumentText />,
    items: [{ name: "クレジット契約準備一覧", path: "/admin/credit-contract-preparation-list" }],
  },
  {
    title: "加盟店（事業者・店舗）",
    icon: <BsBuilding />,
    items: [
      { name: "加盟店申し込み審査", path: "/admin/partner-pre-registrations" },
      { name: "事業者一覧", path: "/admin/companies" },
      { name: "店舗一覧", path: "/admin/stores" },
      { name: "物件登録", path: "/admin/properties/new" },
      { name: "ポップ/チラシ/早見表作成", path: "/admin/pdf" },
      // NOTE: 2分割対応店舗向けの暫定ページ。役目を終えたら /admin/pdf に統合するか削除する
      { name: "ポップ/チラシ/早見表作成（2分割対応店舗）", path: "/admin/pdf-2payment" },
      { name: "パートナーへのお知らせ", path: "/admin/partner-notifications" },
      { name: "キャンペーンバナー", path: "/admin/partner-banners" },
      { name: "加盟店申込ドラフトデータ", path: "/admin/partner-pre-registration-drafts" },
    ],
  },
  {
    title: "立替・送金",
    icon: <MdOutlinePayments />,
    items: [
      { name: "立替申請一覧", path: "/admin/payout-applications" },
      { name: "立替送金申請一覧", path: "/admin/transfer-applications" },
      { name: "送金額計算書", path: "/admin/calculator" },
    ],
  },
  {
    title: "督促管理",
    icon: <MdOutlineWarningAmber />,
    items: [
      { name: "督促ケース一覧", path: "/admin/dunning-cases" },
      { name: "AIプロンプト設定", path: "/admin/dunning-prompt-settings" },
    ],
  },
  {
    // smootherOPE（Rails admin）の債権管理・督促系の画面を移したもの（GEN-1992 Step 5-1）
    title: "債権管理",
    icon: <MdOutlineAccountBalance />,
    items: [
      { name: "口座振込請求", path: "/admin/bank-transfer-invoices" },
      { name: "口座振込結果", path: "/admin/bank-transfer-results" },
      { name: "口座振替請求", path: "/admin/standing-order-invoices" },
    ],
  },
  {
    // smootherOPE（Rails admin）から既存の実装をそのまま移した画面。正式な置き場所が決まるまでここに置く
    title: "レガシー",
    icon: <MdHistory />,
    items: [
      { name: "LINE一斉送信", path: "/admin/bulk-line-messages" },
      { name: "For Finance Payments", path: "/admin/for-finance-payments" },
      { name: "Bank Accounts", path: "/admin/bank-accounts" },
      { name: "支払い履歴一覧", path: "/admin/payments" },
      { name: "消し込み一覧", path: "/admin/reconciliations" },
      { name: "消し込みページ", path: "/admin/reconciliations/manual" },
      { name: "返金一覧", path: "/admin/repayments" },
      { name: "請求停止をした契約一覧", path: "/admin/debt-consolidated-contracts" },
      { name: "遅延ページで非表示にした契約一覧", path: "/admin/guaranteed-contracts" },
      { name: "CIC CSV吐き出し", path: "/admin/gardia-mci" },
      { name: "GANB CSVアップロード", path: "/admin/factoring-csv" },
    ],
  },
  {
    title: "システム管理",
    icon: <RiAdminLine />,
    items: [{ name: "Smoother管理", path: "/admin/smoothers" }],
    adminOnly: true,
  },
]
